import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import SubscriptionDateRangesModel from "../../models/subscription/SubscriptionDateRangesModel";
import SubscriptionFolderModel from "../../models/subscription/SubscriptionFolderModel";
import SubscriptionModel from "../../models/subscription/SubscriptionModel";
import SubscriptionUserModel from "../../models/subscription/SubscriptionUserModel";
import SubscriptionContactModel from "../../models/subscription/SubscriptionContactModel";
import UserDateRangeModel from "../../models/subscription/UserDateRangeModel";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestAllSubscriptionFolders() {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionFoldersPath;
    return EffectUtility.getToModel(SubscriptionFolderModel, endpoint);
}

export async function requestSubscriptionTypes() {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath;
    return EffectUtility.getToModel(SubscriptionModel, endpoint);
}

export async function requestUserSubscriptions(userId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsUsersPath + "/" + userId;
    return EffectUtility.getToModel(SubscriptionModel, endpoint);
}

export async function createSubscriptionType(newSubscriptionType) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath;
    return EffectUtility.postToModel(BaseModel, endpoint, newSubscriptionType);
}

export async function updateSubscriptionType(subscriptionTypeId, newSubscriptionType) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath + "/" + subscriptionTypeId;
    return EffectUtility.putToModel(BaseModel, endpoint, newSubscriptionType);
}

export async function deleteSubscriptionType(subscriptionTypeId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath + "/" + subscriptionTypeId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function requestSubscriptionUsers(subscriptionId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users";
    return EffectUtility.getToModel(SubscriptionUserModel, endpoint);
}

export async function addSubscriptionUser(subscriptionId, userId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId;
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function deleteSubscriptionUser(subscriptionId, userId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function requestUserUnassignedSubscriptionTypes(userId) {
    const endpoint = configuration.apiServer + configuration.apiUserUnassignedSubscriptionTypesPath + "/" + userId;
    return EffectUtility.getToModel(SubscriptionModel, endpoint);
}

// date ranges
export async function requestUserDateRanges(subscriptionId, userId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/dateRanges";
    return EffectUtility.getToModel(SubscriptionDateRangesModel, endpoint);
}

export async function requestAllUserDateRanges(userId) {
    const endpoint =
        configuration.apiServer + configuration.apiUserSubscriptionDateRangesPath + "/" + userId;
    return EffectUtility.getToModel(UserDateRangeModel, endpoint);
}

export async function copyAllUserDateRanges(userId, users) {
    const endpoint =
        configuration.apiServer + configuration.apiUserSubscriptionDateRangesPath + "/" + userId + "/copy";
    return EffectUtility.postToModel(BaseModel, endpoint, users);
}

export async function addUserDateRange(subscriptionId, userId, dateRange) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/dateRanges";
    return EffectUtility.postToModel(BaseModel, endpoint, dateRange);
}

export async function updateUserDateRange(subscriptionId, userId, dateRangeId, dateRange) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/dateRanges/" + dateRangeId;
    return EffectUtility.putToModel(BaseModel, endpoint, dateRange);
}

export async function copyUserDateRange(subscriptionId, userId, dateRangeId, users) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/dateRanges/" + dateRangeId + "/copy";
    return EffectUtility.postToModel(BaseModel, endpoint, users);
}

export async function deleteUserDateRange(subscriptionId, userId, dateRangeId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/dateRanges/" + dateRangeId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

// visibility date
export async function setUserVisibilityDate(subscriptionTypeId, userId, visibilityStartDate) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionTypeId + "/users/" + userId + "/visibility";
    return EffectUtility.putToModel(BaseModel, endpoint, visibilityStartDate, true, true);
}

export async function deleteUserVisibilityDate(subscriptionTypeId, userId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionTypeId + "/users/" + userId + "/visibility";
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

// contacts
export async function requestSubscriptionContacts(subscriptionId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/contacts";
    return EffectUtility.getToModel(SubscriptionContactModel, endpoint);
}

export async function addSubscriptionContact(subscriptionId, email) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/contacts";
    return EffectUtility.postToModel(BaseModel, endpoint, email);
}

export async function updateSubscriptionContact(subscriptionId, contactId, email) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/contacts/" + contactId;
    return EffectUtility.putToModel(BaseModel, endpoint, email);
}

export async function deleteSubscriptionContact(subscriptionId, contactId) {
    const endpoint =
        configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/contacts/" + contactId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

// Reinitialization
export async function reinitializeSubscriptionType(subscriptionTypeId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath + "/" + subscriptionTypeId + "/reinitialize";
    return EffectUtility.putToModel(BaseModel, endpoint);

}

export async function reinitializeUsersSubscription(subscriptionId, userId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/reinitialize";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function reinitializeAndClean(subscriptionTypeId) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionTypesPath + "/" + subscriptionTypeId + "/cleanAndReinitialize";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

// Multiple subscriptions
export async function createMultipleSubscriptions(multipleSubscriptionsData) {
    const endpoint = configuration.apiServer + configuration.apiMultipleSubscriptionsPath;
    return EffectUtility.postToModel(BaseModel, endpoint, multipleSubscriptionsData, true, true);
}